<template>
  <div class="size-container">
    <div class="size-group">
      <p
        v-for="(item, index) in crop_size"
        :key="item.id"
        :class="['size-item', {active: index == currentButtonIndex}]"
        @click="cropBySize(item.width, item.height, index)"
      >
        {{ item.label }}
      </p>
    </div>
    <div class="custom-size">
      <label class="title-label">指定尺寸</label>
      <div>
        <el-input 
          v-model.trim.number="customWidth"
          @change="changeCustomSize"
          @input="checkcustomWidth"
          @keyup.enter.native="changeCustomSize" 
        >
          <i slot="suffix" style="line-height: 34px">宽</i>
        </el-input>
      </div>
      <div style="display:inline-block;width:5px;color: #d2d5dd;">*</div>
      <div>
        <el-input 
          v-model.trim.number="customHeight"
          @change="changeCustomSize"
          @input="checkCustomHeight"
          @keyup.enter.native="changeCustomSize"
        >
          <i slot="suffix" style="line-height:34px;">高</i>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'cropper', 'currentImage' ],
  data () {
    return {
      customWidth: null,
      customHeight: null,
      currentButtonIndex: null,
      crop_size: [
        { id: 0, width: 1080, height: 1920, label: '抖音 1080*1920 px'},
        { id: 1, width: 1146, height: 717, label: 'b站 1146*717 px'},
        { id: 2, width: 1242, height: 1660, label: '小红书 1242*1660 px'},
        { id: 3, width: 1280, height: 1280, label: '知乎 1280*1280 px'},
        { id: 4, width: 720, height: 1280, label: '快手 720*1280 px'},
        { id: 5, width: 900, height: 383, label: '公众号首图 900*383 px'},
        { id: 6, width: 200, height: 200, label: '公众号次图 200*200 px'},
        { id: 7, width: 1080, height: 1080, label: '朋友圈封面 1080*1080 px'},
        { id: 8, width: 259, height: 377, label: '小一寸 259*377 px'},
        { id: 9, width: 295, height: 413, label: '一寸 295*413 px'},
        { id: 10, width: 390, height: 567, label: '大一寸 390*567 px'},
        { id: 11, width: 413, height: 531, label: '小二寸 413*531 px'},
        { id: 12, width: 413, height: 579, label: '二寸 413*579 px'},
        { id: 13, width: 358, height: 441, label: '社保身份证照 358*441 px'},
        { id: 14, width: 260, height: 378, label: '驾驶证照 260*378 px'},
        { id: 15, width: 480, height: 640, label: '大学生毕业图像 480*640 px'},
        { id: 16, width: 240, height: 320, label: '英语四六级照 240*320 px'},
      ]
    }
  },
  watch: {
    'customWidth'() {
      if (!this.customWidth && this.currentButtonIndex == null) {
        this.$message.error('宽度/高度不允许为0或为空');
      }
    },
    'customHeight'() {
      if (!this.customHeight && this.currentButtonIndex == null) {
        this.$message.error('宽度/高度不允许为0或为空');
      }
    }
  },
  methods: {
    checkcustomWidth () {
      // 自定义的值不能超过当前图片的宽高
      if (this.customWidth > this.currentImage.originalWidth) {
        this.customWidth = this.currentImage.originalWidth;
      }
    },

    checkCustomHeight () {
      if (this.customHeight > this.currentImage.originalHeight) {
        this.customHeight = this.currentImage.originalHeight;
      }
    },
    // 自定义宽高
    changeCustomSize () {
      if (!this.customWidth || !this.customHeight) {
        return;
      }
      
      this.cropper.crop();
      this.currentButtonIndex = null;
      this.cropper.setAspectRatio(parseInt(this.customWidth) / parseInt(this.customHeight));
      this.setAspectAndAutoCrop();
      this.$emit('changeCropSize', this.customWidth, this.customHeight);
    },

    // 常用宽高
    cropBySize (width, height, index) {
      // 手动裁剪
      this.cropper.crop();
      this.cropper.setAspectRatio(width / height);
      this.setAspectAndAutoCrop();
      this.$emit('changeCropSize', width, height);

      this.currentButtonIndex = index;
      // 当点击上面的常用比例时，自定义比例清空
      if (this.customWidth || this.customHeight) {
        this.customWidth = null;
        this.customHeight = null;
      }
    },

    // 裁剪框自动撑满图片
    setAspectAndAutoCrop() {
      // 获取图片的当前显示尺寸
      const imageData = this.cropper.getImageData();
      
      const imageWidth = imageData.width;
      const imageHeight = imageData.height;

      let cropWidth, cropHeight;

      // 计算裁剪框的最大尺寸
      const imageAspect = imageWidth / imageHeight;
      if (imageAspect > imageData.aspectRatio) {
        // 图片比目标比例更宽：按高度撑满
        cropHeight = imageHeight;
        cropWidth = cropHeight * imageData.aspectRatio;
      } else {
        // 图片比目标比例更高：按宽度撑满
        cropWidth = imageWidth;
        cropHeight = cropWidth / imageData.aspectRatio;
      }

      // 计算居中位置
      const left = (imageWidth - cropWidth) / 2;
      const top = (imageHeight - cropHeight) / 2;
      
      // 强制更新裁剪框位置和尺寸
      this.cropper.setCropBoxData({
        width: cropWidth,
        height: cropHeight,
        left: left,
        top: top
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.size-container {
  .title-label {
    font-size: 14px;
    line-height: 40px;
    width: 60px;
    font-weight: 400;
    margin-right: 6px;
  }

  .size-group {
    padding: 10px 0;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.4);
    border-radius: 5px;
    margin: 0 10px;
    font-size: 13px;
    .size-item {
      padding: 5px 11px;
      cursor: pointer;
    }

    .size-item.active {
      background-color: #3388FF;
      color: #fff;
    }
  }

  .custom-size {
    padding: 25px 0 10px 11px;
    div {
      width: 85px;
      display: inline-block;
    }

    @media screen and (max-height: 820px) {
      div {
        width: 80px;
      }
    }

    /deep/ .el-input {
      .el-input__inner {
        height: 35px;
        line-height: 35px;
        padding: 0 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/images/crop/commonSize/index.vue